import { createContext, useContext } from 'react'

import type { NavTree } from '@/app/registry'

export const NavContext = createContext<NavTree>({ top: [], children: {}, tabs: [], more: [] })

// Меню приложения, собранное из src/pages/**/routes.tsx.
export function useNavTree(): NavTree {
  return useContext(NavContext)
}
